
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farmbook",
      function () {
        return require("private-next-pages/farmbook/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/farmbook"])
      });
    }
  